// extracted by mini-css-extract-plugin
module.exports = {"table":"style-module--table--2qsaX","table__section":"style-module--table__section--tfw6r"};